import { render, staticRenderFns } from "./CoverGenerator.vue?vue&type=template&id=74cf06ae&"
import script from "./CoverGenerator.vue?vue&type=script&lang=js&"
export * from "./CoverGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports